export const actionSetLogin = (user) => ({
	type: 'SET_LOGIN',
	login: user,
});

export const actionSetIpData = (ipdata) => ({
  type: 'SET_LOGIN_IPDATA',
  ipdata: ipdata,
});